import React, { FunctionComponent } from "react";
import Button from "../Button";
import ButtonProps from "../Button.interface";

const ButtonBrick: FunctionComponent<ButtonProps> = (props) => (
  <Button {...props} type="brick" />
);

export default ButtonBrick;
